import {FormattedMessage} from 'react-intl';
import Utils from '../Common/Utils.js';


const getLastAlimentationFormResDataAndColor = (dataset) => {

    let formResData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set form val
        formResData.res = (Math.round(dataset[dataset.length-1].y*100)/100)

        //Set form val color
        formResData.color = "#21BA45"
    }
    return (formResData);
}


const getLastMDASIFormResDataAndColor = (dataset, threshold, threshold2) => {

    let formResData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set form val
        formResData.res = (Math.round(dataset[dataset.length-1].y*100)/100)

        //Set form val color
        let i = 0
        let ret = 0
        let val = JSON.parse(dataset[dataset.length-1].y)
        while (val[i]) {
            if (val[i].label !== "form_type" && val[i].value > ret) {
                ret = val[i].value
            }
            i++;
        }
        formResData.color = Utils.setMeasureColor(ret, threshold, 0, 'sup', threshold2);
    }
    return (formResData);
}


//Function to get last good form data
const getLastFormResDataAndColor = (dataset, threshold, threshold2) => {

    let formResData = {
        res: "-",
        color: "#767676"
    };
    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set form val
        formResData.res = (Math.round(dataset[dataset.length-1].y*100)/100)

        //Set form val color
		formResData.color = "#21BA45"
    }
    return (formResData);
}


//Function to get last good healthscale data
const getLastHealthscaleDataAndColor = (dataset, threshold, threshold2) => {

    let healthscaleData = {
        healthscale: "-",
        color: "#767676"
    };

    if((dataset !== undefined)&&(dataset.length > 0)){
        //Set healthscale value
        healthscaleData.healthscale = dataset[dataset.length-1].y
        //Set healthscale color
        healthscaleData.color = Utils.setMeasureColor(dataset[dataset.length-1].y, threshold, 20, 'inf', threshold2);
    }
    return (healthscaleData);
}


const splitEQ5D5LFormData = (data) => {
    let ret = {};
    let coefs = {"mobility": [0, 0.058, 0.076, 0.207, 0.274],
                "selfcare": [0, 0.050, 0.080, 0.164, 0.203],
                "usual_activities": [0, 0.050, 0.063, 0.162, 0.184],
                "pain_discomfort": [0, 0.063, 0.084, 0.276, 0.335],
                "anxiety_depression": [0, 0.078, 0.104, 0.285, 0.289]}
    let splitted = JSON.parse(data);
    let disut_total = 0.0;
    splitted.forEach(answer => {
        if (answer.label === "health_scale") {
            ret.health_scale = answer.value;
        }
        if (coefs[answer.label] !== undefined) {
            disut_total += coefs[answer.label][answer.value -1];
        }
    })
    ret.EQindex = 1 - disut_total;
    ret.EQindex = (Math.round(ret.EQindex*100)/100)
    if (ret.EQindex < 0) {
        ret.EQindex = 0;
    }
    return ret;
}


const splitMDASIFormData = (data) => {
    let splitted = JSON.parse(data);
    let lower_result = 10
    splitted.forEach(answer => {
        if (answer.label !== "form_type") {
            if (answer.value < lower_result) {
                lower_result = answer.value
            }
        }
    })
    splitted.push({"label":"lower_result", "value":lower_result})
    return JSON.stringify(splitted);
}


const formatAndMergeEQ5DData = (oldHealthformData, newHealthformData) => {
    
    let local_data = {"form_res": [], "healthscale": []};
    let isANewDateValue = "";

    if (oldHealthformData !== undefined){
        Utils.mergeBasicOldData(oldHealthformData.form_res, local_data.form_res)
        Utils.mergeBasicOldData(oldHealthformData.healthscale, local_data.healthscale)
                }                                           
    if (newHealthformData !== undefined){
        if(newHealthformData.length !== 0){
            for (var i = newHealthformData.length-1; i >= 0; i--){        // Find new values and add it
                isANewDateValue = local_data.form_res.find(xDate => { return xDate.x === new Date(newHealthformData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){
                    let formattedFormData = splitEQ5D5LFormData(newHealthformData[i].value)
                    local_data.form_res.push({x: new Date(newHealthformData[i].eventDate).getTime(), y: Number(formattedFormData.EQindex)})
                    local_data.healthscale.push({x: new Date(newHealthformData[i].eventDate).getTime(), y: Number(formattedFormData.health_scale)})
                }
            }
        }
    }  
    return local_data;
}


const formatAndMergeSF36Data = (oldHealthformData, newHealthformData) => {
    
    let local_data = {"form_res": []};

    if (oldHealthformData !== undefined){
        Utils.mergeBasicOldData(oldHealthformData.form_res, local_data.form_res)
    }
    if (newHealthformData !== undefined){
        Utils.mergeBasicNewData(local_data.form_res, newHealthformData, "sf36")
                }
    return local_data;
}

const formatAndMergeKidneyDeviceData = (oldHealthformData, newHealthformData) => {
  let local_data = { "form_res": [] };

    if (oldHealthformData !== undefined){
        Utils.mergeBasicOldData(oldHealthformData.form_res, local_data.form_res)
    }
    if (newHealthformData !== undefined){
        Utils.mergeBasicNewData(local_data.form_res, newHealthformData, "kidney_device")
    }
    return local_data;
}

const formatAndMergeKidneyBloodData = (oldHealthformData, newHealthformData) => {
    let local_data = {"form_res": []};

    if (oldHealthformData !== undefined){
        Utils.mergeBasicOldData(oldHealthformData.form_res, local_data.form_res)
    }
    if (newHealthformData !== undefined){
        Utils.mergeBasicNewData(local_data.form_res, newHealthformData, "kidney_blood")
    }
    return local_data;
}


const formatAndMergeMDASIData = (oldHealthformData, newHealthformData) => {
    
    let local_data = {"form_res": []};
    let isANewDateValue = "";

    if (oldHealthformData !== undefined){
        Utils.mergeBasicOldData(oldHealthformData.form_res, local_data.form_res)
    }
    if (newHealthformData !== undefined){
        if(newHealthformData.length !== 0){
            for (var i = newHealthformData.length-1; i >= 0; i--){        // Find new values and add it
                isANewDateValue = local_data.form_res.find(xDate => { return xDate.x === new Date(newHealthformData[i].eventDate).getTime() })
                if(isANewDateValue === undefined){
                    let formattedFormData = splitMDASIFormData(newHealthformData[i].value)
                    local_data.form_res.push({x: new Date(newHealthformData[i].eventDate).getTime(), y: formattedFormData})
                }
            }
        }
    }  
    return local_data;
}


const formatAndMergeAlimentationData = (oldHealthformData, newHealthformData) => {

    let local_data = {"form_res": []};
    let isANewDateValue = "";

    if (oldHealthformData !== undefined){
        Utils.mergeBasicOldData(oldHealthformData.form_res, local_data.form_res)
    }
    if (newHealthformData !== undefined){
        Utils.mergeBasicNewData(local_data.form_res, newHealthformData, "alimentation")
                }
    return local_data;
}


//Const to import functions in other files
const HealthformDataManager = {
  formatAndMergeAlimentationData,
  formatAndMergeEQ5DData,
  formatAndMergeSF36Data,
  formatAndMergeMDASIData,
  formatAndMergeKidneyDeviceData,
  formatAndMergeKidneyBloodData,
  getLastHealthscaleDataAndColor,
  getLastFormResDataAndColor,
  getLastMDASIFormResDataAndColor,
  getLastAlimentationFormResDataAndColor
};

export default HealthformDataManager;